import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { RoomAcl, RoomAclGroups, RoomAclMembers, SecurityService } from '@rocksoft/locations-sdk';
import { map, mergeMap } from 'rxjs/operators';
import { safeMap } from '../effects.helpers';
import {
  AccessControlListApiActions,
  RoomAclPermissionsUiActions,
  RoomPermissionsResolverActions,
} from './room-acl.actions';

@Injectable()
export class RoomAclEffects {
  private readonly securityService = inject(SecurityService);
  private readonly actions$ = inject(Actions);

  groupLoadedEffect$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(RoomPermissionsResolverActions.roomAclRequested),
      mergeMap(({ resourceId }) =>
        safeMap(
          this.securityService.getRoomAcls({ resourceId }),
          (roomAcl: RoomAcl) => AccessControlListApiActions.roomAclLoaded({ roomAcl }),
          (error) => AccessControlListApiActions.roomAclLoadedError({ error })
        )
      )
    );
  });

  roomAclMemberPutEffect$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(RoomAclPermissionsUiActions.roomAclMemberPut),
      mergeMap(({ aclMember }) =>
        this.securityService
          .putRoomAclMembers({ resourceId: aclMember.resourceId, roomAclMembers: aclMember })
          .pipe(
            map((roomAclMember: RoomAclMembers) =>
              AccessControlListApiActions.roomAclMemberPut({ aclMember: roomAclMember })
            )
          )
      )
    );
  });

  roomAclGroupPutEffect$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(RoomAclPermissionsUiActions.roomAclGroupPut),
      mergeMap(({ aclGroup }) =>
        this.securityService
          .putRoomAclGroups({ resourceId: aclGroup.resourceId, roomAclGroups: aclGroup })
          .pipe(
            map((roomAclGroup: RoomAclGroups) =>
              AccessControlListApiActions.roomAclGroupPut({ aclGroup: roomAclGroup })
            )
          )
      )
    );
  });
}
